// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/views/Blog/BlogGroup.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/views/Blog/BlogGroup.tsx");
  import.meta.hot.lastModified = "1717182690461.552";
}
// REMIX HMR END

import BlogTeaser from "./BlogTeaser";
export default function BlogGroup({
  items
}) {
  const firstBlog = items[0];
  const restBlogs = items.slice(1);
  return <section className="grid w-full grid-cols-3 gap-8 py-8">
      {firstBlog !== undefined && <BlogTeaser item={firstBlog} variant="full" />}
      {restBlogs.length > 0 && restBlogs.map(blog => <BlogTeaser key={blog.title} item={blog} variant="card" />)}
    </section>;
}
_c = BlogGroup;
var _c;
$RefreshReg$(_c, "BlogGroup");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;